module.exports = __webpack_public_path__ + "img/10blue.181a8a94.png";